"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var CheckCircleOutline_1 = __importDefault(require("@mui/icons-material/CheckCircleOutline"));
var CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));
var pxToRem = function (px) {
    return "".concat(px / 16, "rem");
};
function TagItem(_a) {
    var text = _a.text, icon = _a.icon, onClick = _a.onClick, selected = _a.selected, testId = _a.testId, checkMode = _a.checkMode;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ "data-testid": testId, sx: {
            width: '230px',
            height: '59px',
            backgroundColor: selected ? 'darkGrey.main' : '#FFFFFF',
            borderRadius: '20px',
            boxShadow: selected
                ? '0px 0px 0px #00000014'
                : '0px 2px 12px #00000014',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '25px 20px 25px 20px',
            gap: '12px',
            cursor: 'pointer',
            color: selected ? 'text.primary' : 'darkGrey.main',
            borderColor: selected ? 'transparent' : 'secondary.light',
            borderWidth: selected ? '1px' : '0px',
            borderStyle: 'solid',
            '&:hover': {
                backgroundColor: selected ? 'darkGrey.main' : '#F7F9FA',
                color: 'text.primary',
                boxShadow: '0px 0px 0px #00000014',
            },
        }, onClick: onClick }, { children: [react_1.default.cloneElement(icon, {
                sx: { color: selected ? 'white' : 'text.primary' },
                width: '19px',
                height: '19px',
            }), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body1", color: selected ? 'white' : 'text.primary' }, { children: text })), (0, jsx_runtime_1.jsx)("div", { style: { flex: 1 } }), selected && checkMode && ((0, jsx_runtime_1.jsx)(CheckCircle_1.default, { width: pxToRem(16), height: pxToRem(16), sx: {
                    color: '#62AC6A',
                } })), !selected && checkMode && ((0, jsx_runtime_1.jsx)(CheckCircleOutline_1.default, { width: pxToRem(16), height: pxToRem(16) }))] })));
}
exports.default = TagItem;
TagItem.defaultProps = {
    selected: false,
    testId: undefined,
    checkMode: false,
};
//# sourceMappingURL=TagItem.js.map